import React, { useState } from "react";
import "./RewardsVideo.css";
import { navigate } from "@reach/router";

export default function RewardsVideo() {
  const [startPlaying, setStartPlaying] = useState(false);

  return (
    <div className="container-fluid rewards-video align-items-center position-relative">
      <h2 className="rewards-video-title mb-3">
        Descubre Nuestra Plataforma en Acción
      </h2>
      {!startPlaying ? (
        <img
          onClick={() => setStartPlaying(true)}
          className="cursor-pointer"
          src="/img/video-prob.png"
          alt="tutorial"
        />
      ) : (
        <iframe
          src={`https://player.vimeo.com/video/1073616165`}
          className="video-iframe"
          title="Tutorial Rewards"
          allowFullScreen
        />
      )}
      <button
        style={{ bottom: "-25px" }}
        onClick={() => navigate("/paquetes")}
        className="feat-btn position-absolute start-0 end-0 mx-auto btn rewards-gradient"
      >
        <span className="text-white ">
          COMIENZA YA
          <i className="fas fa-arrow-right ms-2" />
        </span>
      </button>
    </div>
  );
}
